var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGalleryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 3.77777C2 2.79594 2.79594 2 3.77777 2H16.2222C17.204 2 18 2.79594 18 3.77777V16.2222C18 17.204 17.204 18 16.2222 18H3.77777C2.79594 18 2 17.204 2 16.2222V3.77777ZM16.2222 3.77777H3.77777V16.2222H16.2222V3.77777Z",
    fill: "#414143"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.77807 8.41699C7.10271 8.15728 7.564 8.15728 7.88864 8.41699L11.7118 11.4755L12.927 10.2603C13.2742 9.9132 13.837 9.9132 14.1841 10.2603L17.7397 13.8159C18.0868 14.163 18.0868 14.7258 17.7397 15.073C17.3925 15.4201 16.8297 15.4201 16.4826 15.073L13.5556 12.1459L12.4063 13.2952C12.0861 13.6155 11.5762 13.6437 11.2225 13.3607L7.33336 10.2494L3.4442 13.3607C3.06086 13.6674 2.50149 13.6053 2.19482 13.2219C1.88814 12.8386 1.95029 12.2792 2.33364 11.9725L6.77807 8.41699Z",
    fill: "#414143"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7265 6.57345C12.7265 6.08253 13.1245 5.68456 13.6154 5.68456H13.6261C14.117 5.68456 14.515 6.08253 14.515 6.57345C14.515 7.06437 14.117 7.46234 13.6261 7.46234H13.6154C13.1245 7.46234 12.7265 7.06437 12.7265 6.57345Z",
    fill: "#414143"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGalleryIcon);
export default __webpack_public_path__ + "static/media/gallery-icon.61c4ea8fb77cf8568a35943db5c476ee.svg";
export { ForwardRef as ReactComponent };